export const SUPPORTED_LANGUAGES = ['es', 'en'] as const;
export const DEFAULT_LANGUAGE = 'es';

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const isSupportedLanguage = (value: string | undefined): value is SupportedLanguage =>
  SUPPORTED_LANGUAGES.includes(value as SupportedLanguage);
